import axios from "axios";

// Same base URL your Chatbot/chatbotApi.js uses
const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// Save an enquiry lead (old widget: POST {BACKEND_URI}/trip-leads)
export async function submitLead(lead) {
  const { data } = await axios.post(`${BASE_URL}/api/trip-leads`, lead);
  return data;
}

// After a payment redirect (old widget: POST {BACKEND_URI}/payment/payment-success)
export async function confirmPayment(payload) {
  const { data } = await axios.post(`${BASE_URL}/api/payment/payment-success`, payload);
  return data;
}
